<template lang="html">
  <div :class="className">
    <input type="file" class="form-control upload" @change="choseFile($event)" multiple>
    <ul v-if="files[0].name" class="files__list">
      <li v-for="(file, index) in files" :key="index" class="files__list__item" @click="removeFile(index)">
        <i class="far fa-times-circle delete"></i>
        <i :class="'far fa-' + getIcon(file.type)"></i>
        {{file.name}}
      </li>
    </ul>
  </div>
</template>

<script>
import { getFileIcon } from '_utils/';

export default {
  name: 'upload-file-list',
  props: {
    className: {
      type: [String, Object, Array],
    },
    model: {
      type: [Array, Object],
    },
  },
  computed: {
    files: {
      get() {
        return this.model;
      },
      set(value) {
        this.$emit('update:model', value);
      },
    },
  },
  components: {},
  methods: {
    choseFile(event) {
      const { files } = event.target;
      this.files = Array.from(files);
    },
    getIcon(type) {
      return getFileIcon(type);
    },
    removeFile(index) {
      this.files.splice(index, 1);
    },
  },
  mounted() {},
};
</script>


<style lang="scss" scoped>
.files__list {
  font-size: 1rem;
  list-style: none;
  padding-left: 6px;
  &__item {
    padding: 7px 4px 7px 30px;
    .delete {
      display: none;
    }
    &:hover{
      background: #ebebeb;
      padding-left: 4px;
      cursor: pointer;
      .delete {
        display: inline-block;
      }
    }
    i {
      font-size: 1.3rem;
      &.fa-times-circle{
        font-size: 1rem;
        margin-right: 10px;
      }
    }
  }
}
</style>
